import { render, staticRenderFns } from "./DraftListEditA3.vue?vue&type=template&id=44b5cea6"
import script from "./DraftListEditA3.vue?vue&type=script&lang=js"
export * from "./DraftListEditA3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports